import React, { useEffect, useRef, useState } from 'react'
import "./ServiceCards.css"
import { useNavigate } from 'react-router-dom'

const cardData = [
    {
        name:"Sport medicine",
        link:"/sports-medicine",
        img:"/images/creatives/service-main-1.webp"
    },
    {
        name:"Audiology",
        link:"/audiology",
        img:"/images/creatives/service-main-2.webp"
    },
    {
        name:"Dna analysis",
        link:"/dna-clinical-testing",
        img:"/images/creatives/service-main-3.webp"
    },
    {
        name:"Global Medical Consulting",
        link:"/global-medical-consulting",
        img:"/images/creatives/service-main-4.webp"
    },
    // {
    //     name:"Gyno uro",
    //     link:"/gyno-uro-clinic",
    //     img:"/images/creatives/service-main-5.webp"
    // },
    {
        name:"Medical aesthetics",
        link:"/medical-aesthetics",
        img:"/images/creatives/service-main-6.webp"
    },
    {
        name:"Aging & wellness",
        link:"/aging-wellness-clinic",
        img:"/images/creatives/service-main-7.webp"
    },
    {
        name:"IV therapy",
        link:"/iv-therapy-boost-shots",
        img:"/images/creatives/service-main-8.webp"
    },
    {
        name:"Naturopathic medicine",
        link:"/naturopathic-medicine",
        img:"/images/creatives/service-main-9.webp"
    },
    {
        name:"Orthopaedic",
        link:"/orthopaedic-clinic",
        img:"/images/creatives/service-main-10.webp"
    },
    // {
    //     name:"Pelvic floor Men",
    //     link:"/mens",
    //     img:"/images/creatives/service-main-11.webp"
    // },
    // {
    //     name:"Pelvic floor Women",
    //     link:"/women",
    //     img:"/images/creatives/service-main-11.webp"
    // },
]

function ServiceCards() {
      const cardRef = useRef()
      const [boxHeight,setBoxHeight] = useState("180px")
    const navigate = useNavigate()

      useEffect(()=>{
          const recalcHeight = ()=>{
            setBoxHeight(`${cardRef.current?.offsetWidth}px`)
          }
    
          recalcHeight()
    
          window.addEventListener("resize", recalcHeight);
          return () => window.removeEventListener("resize", recalcHeight);
        },[])
  return (
    <div className='ServiceCards-container standard-padding-space'>
        <div className='container'>
            <div className='row gy-4'>
                {
                    cardData.map((ele)=>{
                        return(
                            <div className='col-lg-4 px-3'>
                                <div className='service-card-box p-2'>
                                    <div className='service-card w-100 ' ref={cardRef} style={{backgroundImage:`url(${ele.img})`,height:boxHeight}} onClick={()=>{navigate(ele.link)}}>
                                        <div className='grey-bar'><h5 className='color-light my-3 px-2'>{ele.name}</h5></div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </div>
  )
}

export default ServiceCards